import { createMachine, assign } from 'xstate';
import { attenteMachine } from './attenteMachine';
import { accroupieMachine } from './accroupieMachine';
import { allongeeMachine } from './allongeeMachine';
import { assiseMachine } from './assiseMachine';
import { bagarreMachine } from './bagarreMachine';
import { danceMachine } from './danceMachine';
import { marcheMachine } from './marcheMachine';

export const catrineMachine = createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QGMCGAXATgSwHZgDoN0xcSBiWAd23WQAsACY0kgbQAYBdRUABwD2sWtgG5eIAB6IALAHYCADgDMATkUBWAEwBGGYo6qOc5QBoQAT0TLjighx2rlANhmrdirYoC+382iw8QhYyMEoaOiZUZGRMAQBXPmwwTh4kEEFhdFFxdOkEZR1ne2ctDR05Dm0tNTNLRA1XAg0OVo4bOSMdRR8-EACcfCJ0ElDw2gZmWGFYFO4JTJExCXzC4o5S8srq2vMrBF1VDQI5Fr0erRkr5RlffwxB4JHWMOoJqIAbD7EYObT+IRLXKgVZFEplCpVLQ1Jx7RCXZQKMoOZTKFrOVSYu79B5BYajChvSKMAC2qEwDD+C0B2WWeWsYI2EO20N29QOmg49laRS06kMp2xAzxIUJEUmACNUFByZgqelFrTgVIGetNpCdrD2YodAQ3JjMSoHHoNL17oEhqLXuKmBBULhkPKAVkcitVeCtlCYXV9lp2sdkUUNnJOiozTiLcEYnFEslxsSralqS66SDEI5OgQbPo5JdVJ0tHJnHCEM5NARkQ4aqVHMohbjLdGEklre9mE3Y06MjTXfSDt1dWWi5oympNDISzoHKpmm05DpGojFPP65GiB2W-HJqhpthZkmFT3UyqEI5y85XMiZDobjUJ+yp+pua13Bfuho5KvHuvYs240Tty+H4wC7RVezTU9VAxAh3D9GREVUHQ-RvSdURnFpjSQrw-Q0DQvxFDd-xtUlyUpA9nSBN1IJDLMXA4HpShMQtiwfK4uQwnQ9Hkecp1uPphUbX9Oy3JgpRlTA5XI7sU2VfJq2UZpSgxIpMQ4LRnB9dMNi5RDnFODRMRaFd+IbKMhM3ADbXtR0pLA498jPBRWgMG9ORcRQWP2ExjlOVpXB1Gobh0fDLSA3BfhE5hnlCWyj1k9MigUGQ+U0JxlwXI4SzKU1nyQ019ELQUTLXVAwoiyz23M5JYpkqiFw0BTly2aEGsaKpJw8E4MM5dobzw4rv1K75wpAyKdxmUC4rqioFLkRR3ERGx1NwuQsscYoeiMNQ1OcQxwwE4IytGiqhuAybar7PqdOcTiHBkC9MVW9ldG6LNNr0qc7xCw7hvK4iyQpehzsoy7cMa04KhatFdo0Nabr1KC-WhS9OO+ogjtbYkxNlYGlTqsGlAh3NRza2GH0aXVK3m5dXHcPjzUGjHIrtB1cfAk9ONOAgbxsVoTCghxJ00BTKycPK1DkemI0G3dZjG6L2HmQ8LogkNdTcaFOVcRwdCytZZzuzjnA-XQ6wGkVZcx7dCLZ+yEvkGDEQMzobAMrQS3zJEMIveC9I8z9zctS2xstmqQYgo4tCUVQZAM435xuXM1oqCsziuC9PAxfqGYtiaxoxsO8cuvQFCcU58ycKp3DW+63qMDR4PghutDR8a9ytpgAbIpWKKLiDOIdsvncrt2st2uwOLmlLrw81vg4q7GJNt+LTxLx3y5dqv3fZa4Tn1MujkUdO57ziqWZsnvpPDk8QxnRxm+1i9lGhLK1JkA2Km6Pz6P20yCEXuU8sCTLyojUFQ9gG46iLHBMoJZCjuA-pCLwrhERowAR3SqMYWyF3ZnJFwClGjqV0qpdSmlV6cT1IlGQwZoEmDQdKHGIcJo4LtgcZQ81KHJQ0jYNEGw4F6Cjm0G8d5x6S3oeJQBJ0C6XzsivGoJgCAfXUPNG8GIj5wMMLqDi8gn4NWCoHQg6DIpdyBiwuR7DdT0RuhiLw+orhj1RIos4pxoTQm6FLA6-8GFL0iugsxoCDIzjKNQrOApPLpm4l1BwO1Si6DcOIxhZ9rIgL7DCLkpxOimnzMg8JBw1IVn3roBOdNf5rnPhgxMMipp9lRMcXC8gpySywpce8+wzzv18hUQJzcio5yGOUsaNt-F9hcc+NSdFoHPxLJoYoGEqjzgajdMoaMBknVDlUlWN9tBjOrMYUoUznrGGOEIxo+g1jZ2lniVZxFTojRSarbZbRxm7UmdvNp+Z35CNrC0e6pTvzXLbCY+5WzBFtF2a8ycTEP58yPpxdwKzkm+O8ZJDZ198ijKeeC-ZbzrDQhggaI+5R1KVA8X-AFxJynDIgkZRRXgy5a0bpOI4QSzhVAxEsooaMgVAJeFSjmH4FIuHnEpCW80yF8kqFE+qz8oZctIkDQZVVgUOWZUoJCN1eJ9XUKhIwYzmWNJugHPphBuVrOYaivu-LMy5gvPRGVy52hZVzCyhwlQNJQXzHKwGFTpH-Cvpahyi4YJH3ujHMsNQX7PRevim6Hkw3Di9ZSYx8rlXphDFyGGhC9JeFHs9BqXIhGIXotea8iaFUL2RamyCBk1XqVuteNE2q81IRgjyTwPRDCkrXKa4ilKLW4PTKaSxlQeGYlZMYScGqpXFuSrC3wfRcACAgHACQB1kxosQAAWl1uyTd6wnkHp5LoVuCswDroDbIJ6+xCiOPKE4Nwu14Ihtbjbc9A7+y6oMmoG8zk3CTiOXqlEKIPytwxm+1hfV34BWzXoZ+XS1oKM2tOXClwdQn3buBleMc7BNQFJ4N+PQENR06XyXhmcElL0w6A3aXJ4JFh4UWM5k4GoizOLoTWi5nAItZlRvsLQo5DzvNkgwOK8l6ClUO+66llkGIIEC3j-d01SsfIUBweksqmjqTyDJF4MR0PnUAA */
  id: 'catrine',
  initial: 'attente',
  states: {
    attente: {
      invoke: {
        id: 'attente',
        src: attenteMachine
      },
      on: {
        "switch attente": "attente",
        "switch accroupie": "accroupie",
        "switch assise": "assise",
        "switch allongee": "allongee",
        "switch marche": "marche",
        "switch bagarre": "bagarre",
        "switch dance": "dance"
      }
    },
    accroupie: {
      invoke: {
        id: 'accroupie',
        src: accroupieMachine
      },
      on: {
        "switch attente": "attente",
        "switch accroupie": "accroupie",
        "switch assise": "assise",
        "switch allongee": "allongee",
        "switch marche": "marche",
        "switch bagarre": "bagarre",
        "switch dance": "dance"
      }
    },
    allongee: {
      invoke: {
        id: 'allongee',
        src: allongeeMachine
      },
      on: {
        "switch attente": "attente",
        "switch accroupie": "accroupie",
        "switch assise": "assise",
        "switch allongee": "allongee",
        "switch marche": "marche",
        "switch bagarre": "bagarre",
        "switch dance": "dance"
      }
    },
    assise: {
      invoke: {
        id: 'assise',
        src: assiseMachine
      },
      on: {
        "switch attente": "attente",
        "switch accroupie": "accroupie",
        "switch assise": "assise",
        "switch allongee": "allongee",
        "switch marche": "marche",
        "switch bagarre": "bagarre",
        "switch dance": "dance"
      }
    },
    bagarre: {
      invoke: {
        id: 'bagarre',
        src: bagarreMachine
      },
      on: {
        "switch attente": "attente",
        "switch accroupie": "accroupie",
        "switch assise": "assise",
        "switch allongee": "allongee",
        "switch marche": "marche",
        "switch bagarre": "bagarre",
        "switch dance": "dance"
      }
    },
    dance: {
      invoke: {
        id: 'dance',
        src: danceMachine
      },
      on: {
        "switch attente": "attente",
        "switch accroupie": "accroupie",
        "switch assise": "assise",
        "switch allongee": "allongee",
        "switch marche": "marche",
        "switch bagarre": "bagarre",
        "switch dance": "dance"
      }
    },
    marche: {
      invoke: {
        id: 'marche',
        src: marcheMachine
      },
      on: {
        "switch attente": "attente",
        "switch accroupie": "accroupie",
        "switch assise": "assise",
        "switch allongee": "allongee",
        "switch marche": "marche",
        "switch bagarre": "bagarre",
        "switch dance": "dance"
      }
    }
  }
});
